import { render, staticRenderFns } from "./Variants.vue?vue&type=template&id=19327c80&scoped=true"
import script from "@/views/Variants/Variants.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/Variants.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/variants.scss?vue&type=style&index=0&id=19327c80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19327c80",
  null
  
)

export default component.exports